<template>
    <v-row>
        <v-col cols="2">
            <template v-for="item in jobDtl">
                <v-row class="onJobHeader">{{ item.header }}</v-row>
                <v-row style="font-size: 2em">{{ item.info }}</v-row>
            </template>
        </v-col>
        <v-col cols="3">
            <v-card variant="outlined" rounded height="300">
                <v-row class="ma-2">
                    <v-col>
                        <v-text-field
                            v-model="madeQty"
                            label="Quantity Made"
                            type="number"
                            step="1"
                            variant="outlined"
                            class="mt-2"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col class="text-center" style="font-size: 2em"
                        >Scrap
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="scrapQty"
                            label="Qty"
                            type="number"
                            min="0"
                            step="1"
                            variant="outlined"
                            class="ml-2"
                            :error-messages="errorMsgScrap"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="selectedReason"
                            :items="scrapReasons"
                            item-title="text"
                            item-value="value"
                            label="Reason"
                            variant="outlined"
                            class="mr-2"
                            :error-messages="errorMsgReason"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col>
            <v-row>
                <v-col cols="12">
                    <v-btn
                        color="green"
                        @click="handleClockOut"
                        variant="elevated"
                        size="large"
                        :disabled="disableClockOut"
                    >
                        <span class="button-text">Clock Out</span>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-btn
                        color="error"
                        @click="closeEmployeePunchScreen"
                        min-width="140"
                        size="large"
                        variant="elevated"
                    >
                        <span class="button-text">Exit</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "Quantity Entry",
    emits: [
        "closeEmployeePunchScreen",
        "closeManagerPunchScreen",
        "clockOutJob",
        "clockOutDetails",
    ],
    props: {
        jobInfo: {
            type: Object,
            default: null,
        },
        punchName: {
            type: String,
            default: null,
        },
        punchID: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            clockInEmpID: "",
            clockOutView: false,
            clockOutDetails: [],
            errorMsg: [],
            errorMsgMade: [],
            errorMsgScrap: [],
            errorMsgReason: [],
            scrapQty: 0,
            madeQty: 0,
            selectedReason: null,
            scrapReasons: [
                { text: "", value: "" },
                { text: "Assembly Scrap", value: "ASM" },
                { text: "CNC Scrap", value: "CNC" },
                { text: "Purchased Parts Scrap", value: "PUR" },
                { text: "Silkscreen Scrap", value: "SIL" },
            ],
            jobDtl: [
                { header: "Job Number", info: this.jobInfo.JobNum },
                { header: "Assembly Seq", info: this.jobInfo.AsmSeq },
                { header: "Operation Seq", info: this.jobInfo.OprSeq },
            ],
        };
    },
    watch: {
        scrapQty(newVal) {
            if (newVal > 0 && !this.selectedReason) {
                this.errorMsgReason.push("Reason required");
            } else {
                this.errorMsgReason = [];
            }

            if (newVal === null || newVal === "" || newVal < 0) {
                this.errorMsgScrap.push("Valid quantity required");
            } else {
                this.errorMsgScrap = [];
            }
        },
        // madeQty(newVal) {
        //     if (newVal === null || newVal === "" || newVal < 0) {
        //         this.errorMsgMade.push("Valid quantity required");
        //     } else {
        //         this.errorMsgMade = [];
        //     }
        // },
        selectedReason(newVal) {
            if (newVal && this.scrapQty < 1) {
                this.errorMsgScrap.push("Valid quantity required");
            } else {
                this.errorMsgScrap = [];
            }

            if (newVal && this.scrapQty > 0) {
                this.errorMsgReason = [];
            }

            if (newVal === "" && this.scrapQty > 0) {
                this.errorMsgReason.push("Reason required");
            }
        },
    },
    computed: {
        disableClockOut() {
            if (
                this.madeQty === null ||
                this.madeQty === "" ||
                this.madeQty === 0 ||
                this.scrapQty < 0 ||
                this.scrapQty === null ||
                this.scrapQty === "" ||
                (this.scrapQty > 0 && !this.selectedReason) ||
                (this.scrapQty < 1 && this.selectedReason)
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        handleClockOut() {
            this.sendClockOutDetails();

            this.closeEmployeePunchScreen();

            this.clockOutJob();
        },
        clockOutJob() {
            this.$emit("clockOutJob");
        },
        closeEmployeePunchScreen() {
            this.$emit("closeEmployeePunchScreen");
        },
        closeManagerPunchScreen() {
            this.$emit("closeManagerPunchScreen");
        },
        sendClockOutDetails() {
            this.clockOutDetails.empID = this.punchID;
            this.clockOutDetails.name = this.punchName;
            this.clockOutDetails.laborQty = this.madeQty;
            this.clockOutDetails.scrapQty = this.scrapQty;
            this.clockOutDetails.scrapReason = this.selectedReason;
            this.$emit("clockOutDetails", this.clockOutDetails);
        },
    },
};
</script>

<style>
.onJobHeader {
    font-size: 1.25em;
    text-decoration: underline;
    font-weight: 900;
}

.custom-large-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    padding: 60px 60px;
    width: 20%;
}

.button-text {
    display: inline-block;
}
</style>
